import getGlobalObject from './getGlobalObject';

const _p = {
    getGlobalObject
};

export const _private = _p;

// @ts-ignore
// eslint-disable-next-line no-undef
export default () => (_p.getGlobalObject().location.host.includes('sst') ? 'sst' : __BRAND__ ?? 'redbeam');
